import * as angular from 'angular';
import { MeurhAdmissoesestagiarioDependentesFormController } from './dependentes.form.controller';

export class MeurhAdmissoesestagiarioDependentesFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesestagiarioDependentesFormComponent';
	static controller = MeurhAdmissoesestagiarioDependentesFormController;
	static template = require('!!html-loader!./dependentes.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '=',
		busy: '=',
		action: '<',
	};
}
